import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BotComponent } from './bot/bot.component';
import { RolesComponent } from './roles/roles.component';
import { DominiosComponent } from './dominios/dominios.component';
import { BaseConocimientoComponent } from './base-conocimiento/base-conocimiento.component';
import { AgentesComponent } from './agentes/agentes.component';

import { CoreModule } from '../core/core.module';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '../../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from '../util/util.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { JustinoRoutingModule } from './justino-routing.module';
import { ModalNomDesComponent } from './modal-nom-des/modal-nom-des.component';
import { ModalSelecEleComponent } from './modal-selec-ele/modal-selec-ele.component';
import { QuestionCrudComponent } from './question-crud/question-crud.component';
import { JustinoAnimeComponent } from './justino-anime/justino-anime.component';
import { AdminMasComponent } from './admin-mas/admin-mas.component';
import { ModalInteraccionComponent } from './modal-interaccion/modal-interaccion.component';
import { InteraccionComponent } from './interaccion/interaccion.component';
import { QuillModule } from 'ngx-quill';
import { EjemploComponent } from './ejemplo/ejemplo.component';
import { ModalEjemploComponent } from './modal-ejemplo/modal-ejemplo.component';
import { ChatComponent } from './chat/chat.component';
import { IntroJustinoComponent } from './intro-justino/intro-justino.component';
import { EncuestaComponent } from './encuesta/encuesta.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { FilterPipe } from './filter.pipe';
import { GestionVideosComponent } from './gestion-videos/gestion-videos.component';
import { ModalEditarVideoComponent } from './modal-editar-video/modal-editar-video.component';
import { GestionFuncionalidadesComponent } from './gestion-funcionalidades/gestion-funcionalidades.component';
import { GestionInformacionComponent } from './gestion-informacion/gestion-informacion.component';
import { ModalEditarInfoDocsEntComponent } from './modal-editar-info-docs-ent/modal-editar-info-docs-ent.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TimelineComponent } from './timeline/timeline.component';
import { ModalEditarTituloComponent } from './modal-editar-titulo/modal-editar-titulo.component';
import { ModalVideoComponent } from './modal-video/modal-video.component';
import { RecuadroJustinoComponent } from './recuadro-justino/recuadro-justino.component';
import { SafeHtmlPipe } from './chat/safe-html.pipe';
import { ConsentimientoComponent } from './consentimiento/consentimiento.component';

@NgModule({
  declarations: [
    BotComponent,
    RolesComponent,
    DominiosComponent,
    BaseConocimientoComponent,
    AgentesComponent,
    ModalNomDesComponent,
    ModalSelecEleComponent,
    QuestionCrudComponent,
    JustinoAnimeComponent,
    AdminMasComponent,
    ModalInteraccionComponent,
    InteraccionComponent,
    EjemploComponent,
    ModalEjemploComponent,
    ChatComponent,
    IntroJustinoComponent,
    EncuestaComponent,
    FilterPipe,
    GestionVideosComponent,
    ModalEditarVideoComponent,
    GestionFuncionalidadesComponent,
    GestionInformacionComponent,
    ModalEditarInfoDocsEntComponent,
    TimelineComponent,
    ModalEditarTituloComponent,
    ModalVideoComponent,
    RecuadroJustinoComponent,
    SafeHtmlPipe,
    ConsentimientoComponent
  ],
  imports: [
    CommonModule,
    UtilModule,
    CoreModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    AppRoutingModule,
    NgSelectModule,
    QuillModule.forRoot(),
    JustinoRoutingModule,
    NgxPaginationModule,
    TranslatePipe,
  ],
  exports: [
    JustinoAnimeComponent,
    RecuadroJustinoComponent
  ]
})
export class JustinoModule {}
